import React from 'react'

const Updateproduct = () => {
  return (
    <div>updateproduct</div>
  )
}

export default Updateproduct